import { NgModule } from '@angular/core';

import { LayoutComponent } from './layout.component';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LoaderComponent } from '../_commonComponents/loader/loader.component';
import { CopilotComponent } from '../_commonComponents/copilot/copilot.component';
import { FormsModule } from '@angular/forms';
@NgModule({
  declarations: [CopilotComponent, LayoutComponent, SidebarComponent, TopbarComponent, LoaderComponent],
  imports: [CommonModule, RouterModule, SharedModule, FormsModule],
  providers: []
})
export class LayoutModule {}
